import { navigateBack } from 'actions/main';
import { modalMinimizeWidget } from 'actions/workflows-v2/workflowsV2';
import { setSelectedArticle } from 'actions/workflows/workflows';
import { useAppDispatch, useAppSelector } from 'hooks';
import { useEffect } from 'react';
import { selectIsInteractiveEmail } from 'reducers/config';
import { selectIsArticlePage, selectIsWidgetVisible } from 'reducers/main';
import {
  addScreenReaderNotification,
  selectIsBuilderPreview,
} from 'reducers/workflows';
import { selectCustomConfigParams } from 'reducers/workflows/index';

export default function useEscapeKeyHandler() {
  const dispatch = useAppDispatch();
  const isArticlePage = useAppSelector(selectIsArticlePage);
  const isWidgetVisible = useAppSelector(selectIsWidgetVisible);
  const isBuilderPreview = useAppSelector(selectIsBuilderPreview);
  const isInteractiveEmail = useAppSelector(selectIsInteractiveEmail);
  const customConfigParams = useAppSelector(selectCustomConfigParams);
  const disableClose = customConfigParams?.disable_close === 'true';

  useEffect(() => {
    const listener = (event: KeyboardEvent) => {
      if (!isWidgetVisible || event.key !== 'Escape' || disableClose) {
        return;
      }

      event.preventDefault();

      if (isArticlePage) {
        dispatch(setSelectedArticle(undefined));
        dispatch(navigateBack());
        dispatch(addScreenReaderNotification('Article closed'));

        return;
      }

      if (!isInteractiveEmail && !isBuilderPreview) {
        dispatch(modalMinimizeWidget());
      }
    };

    // `document.body` can be `null`
    document.body?.addEventListener('keydown', listener);

    return () => {
      // `document.body` can be `null`
      document.body?.removeEventListener('keydown', listener);
    };
  }, [
    dispatch,
    isArticlePage,
    isWidgetVisible,
    isInteractiveEmail,
    isBuilderPreview,
    disableClose,
  ]);
}
